import { TEvent } from '@ws/shared/types';

import { SyncState } from '../EventTrain/SyncState';

// Токен сессии синхронизации. projectId + generation однозначно идентифицируют
// конкретное открытие проекта: A→B→A даёт разные generation, поэтому поздние
// ответы старой сессии отсекаются даже при совпадающем projectId.
export type TSyncSessionToken = { projectId: string; generation: number };

// Read-only снимок локальной sync-записи проекта. Чтение НЕ создаёт запись
// (в отличие от старого getSyncState) — создание только через createSyncState.
export type TSyncStateInfo =
  | { kind: 'enabled'; state: SyncState<TEvent> }
  | { kind: 'disabled'; state: SyncState<TEvent> }
  | { kind: 'missing' }
  | { kind: 'invalid' }
  | { kind: 'storage-error'; error: unknown };

export const sameToken = (a?: TSyncSessionToken | null, b?: TSyncSessionToken | null): boolean =>
  !!a && !!b && a.projectId === b.projectId && a.generation === b.generation;
